<template>
  <div class="main-wrapper">
    <transition name="fade">
      <router-view :key="key"></router-view>
    </transition>
  </div>
</template>
<script>
  export default {
    name: 'app-main',
    computed: {
      key() {
        return this.$route.name !== undefined
          ? this.$route.name + new Date()
          : this.$route + new Date()
      }
    }
  }
</script>
<style>
  .fade-enter-active {
    animation-name: fade-in;
    animation-duration: .6s;
  }
  .fade-leave-active {
    opacity: 0;
    display: none;
  }
  @keyframes fade-in {
    0% {
      opacity: 0.4;
    }
    100% {
      opacity: 1;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/AppMain.vue